import type videojs from 'video.js'

export type AudioTrack = videojs.AudioTrack & {
  kind?: string
  id: string
  label?: string
  language?: string
}

export interface AudioTrackList extends EventTarget {
  readonly length: number
  [index: number]: AudioTrack
}

export const TEXT_TRACK_KIND = {
  Subtitles: 'subtitles',
  Captions: 'captions',
  Chapters: 'chapters',
  Descriptions: 'descriptions',
  Metadata: 'metadata',
} as const
export type TEXT_TRACK_KIND =
  (typeof TEXT_TRACK_KIND)[keyof typeof TEXT_TRACK_KIND]

export const TEXT_TRACK_LABEL = {
  SegmentMetadata: 'segment-metadata',
  AdCues: 'ad-cues',
} as const
export type TEXT_TRACK_LABEL =
  (typeof TEXT_TRACK_LABEL)[keyof typeof TEXT_TRACK_LABEL]

export const TRACK_MODE = {
  Disabled: 'disabled',
  Showing: 'showing',
  Hidden: 'hidden',
} as const
export type TRACK_MODE = (typeof TRACK_MODE)[keyof typeof TRACK_MODE]

export interface PlayerTextTrack {
  id: string
  label: string
  language: string
  kind: string
  mode: TRACK_MODE
}
